module.exports = __webpack_public_path__ + "ls.a85b37cf455c01e0effd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ls.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ls.svg
// module chunks = styles